import { render, staticRenderFns } from "./NamedValue.vue?vue&type=template&id=641d9d2e&scoped=true&"
import script from "./NamedValue.vue?vue&type=script&lang=js&"
export * from "./NamedValue.vue?vue&type=script&lang=js&"
import style0 from "./NamedValue.vue?vue&type=style&index=0&id=641d9d2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641d9d2e",
  null
  
)

export default component.exports